import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const usersStore = {
    actionCreators,
    reducer,
};

export default usersStore;
